import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:5001', // or your deployed backend URL
  baseURL: 'https://server.slotify.ir',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token automatically if you use JWT later
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Management screens must always read the latest database state. Without a
  // unique query value, the browser can reuse the GET response that existed
  // before a successful PUT and make an edit look as if it was never saved.
  if (config.method?.toLowerCase() === 'get') {
    config.params = {
      ...config.params,
      _ts: Date.now(),
    };
    config.headers['Cache-Control'] = 'no-cache';
    config.headers.Pragma = 'no-cache';
  }

  return config;
});

export default api;
